import { SlideAccordion } from "@/components/common/select/SlideAccordion";

const FilterSection = ({
  open,
  onToggle,
  title,
  subtitle,
  children,
}: {
  open: boolean;
  onToggle: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className="
        mb-4 rounded-2xl
        border border-white/10
        bg-white/5 backdrop-blur-md
        shadow-[0_10px_30px_rgba(0,0,0,0.25)]
        overflow-hidden
      "
    >
      {/* Header */}
      <button
        type="button"
        onClick={onToggle}
        data-testid="filter-toggle-button"
        className="
          w-full flex items-center justify-between
          px-4 py-3
          text-sm text-white/85
          hover:bg-white/5
          transition
        "
      >
        <div className="text-left min-w-0">
          <div className="font-medium">{title}</div>
        </div>

        <span
          className={`
            ml-3 shrink-0 text-xs text-white/60
            transition-transform duration-300
            ${open ? "rotate-180" : ""}
          `}
        >
          ▼
        </span>
      </button>

      <div className="h-px bg-white/10" />
      <SlideAccordion open={open}>
        <div
          className="
            px-2 sm:px-4
            bg-black/20
            pb-4
          "
        >
          {children}
        </div>
      </SlideAccordion>
    </div>
  );
};

export default FilterSection;